module.exports = __webpack_public_path__ + "static/media/ruby.8cce8196.png";